var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full lg:w-1/2"},[_c('CommonTeacherReviewScores',{attrs:{"items":_vm.numbers,"hidden-stars":""}})],1),_vm._v(" "),_c('CommonTeacherReviewComments',{staticClass:"mt-4",attrs:{"list":_vm.comments}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }